import { VehiclePartsService } from '../../../epics/common/commonData';
import {
    accessoryPartsKey,
    brakesPartsKey,
    carbodyPartsKey,
    electricPartsKey,
    enginePartsKey,
    equipmentPartsKey,
    gasEquipmentPartsKey,
    heatingPartsKey,
    interiorPartsKey,
    maintenancePartsKey,
    namePartsKey,
    statePartsKey,
    suspensionPartsKey,
    transmissionPartsKey,
    typePartsKey,
    tyreSeasonPartsKey,
    wheelsBoltsPartsKey,
    wheelsPartsKey,
    wheelsRadiusPartsKey,
    wheelsWidthPartsKey,
} from '../thunkKeys/partsThunksKeys';
import { createAsyncThunkWithCaching } from '../../thunkWrapper';

export const getAccessoryParts = createAsyncThunkWithCaching(
    accessoryPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getAccessoryParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getBrakesParts = createAsyncThunkWithCaching(
    brakesPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getBrakesParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getCarbodyParts = createAsyncThunkWithCaching(
    carbodyPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getCarbodyParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getElectricParts = createAsyncThunkWithCaching(
    electricPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getElectricParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getEngineParts = createAsyncThunkWithCaching(
    enginePartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getEngineParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getEquipmentParts = createAsyncThunkWithCaching(
    equipmentPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getEquipmentParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getGasEquipmentParts = createAsyncThunkWithCaching(
    gasEquipmentPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getGasEquipmentParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getHeatingParts = createAsyncThunkWithCaching(
    heatingPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getHeatingParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getInteriorParts = createAsyncThunkWithCaching(
    interiorPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getInteriorParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getMaintenanceParts = createAsyncThunkWithCaching(
    maintenancePartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getMaintenanceParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getNameParts = createAsyncThunkWithCaching(
    namePartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getNameParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getStateParts = createAsyncThunkWithCaching(
    statePartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getStateParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getSuspensionParts = createAsyncThunkWithCaching(
    suspensionPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getSuspensionParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getTransmissionParts = createAsyncThunkWithCaching(
    transmissionPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getTransmissionParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getTypeParts = createAsyncThunkWithCaching(
    typePartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getTypeParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getTyreSeasonParts = createAsyncThunkWithCaching(
    tyreSeasonPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getTyreSeasonParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getWheelsBoltsParts = createAsyncThunkWithCaching(
    wheelsBoltsPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getWheelsBoltsParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getWheelsParts = createAsyncThunkWithCaching(
    wheelsPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getWheelsParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getWheelsRadiusParts = createAsyncThunkWithCaching(
    wheelsRadiusPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getWheelsRadiusParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getWheelsWidthParts = createAsyncThunkWithCaching(
    wheelsWidthPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehiclePartsService.getWheelsWidthParts();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);
